import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Select, MenuItem, Button, Collapse, Card, CardContent, Checkbox, Popover, FormControlLabel, FormGroup, IconButton } from "@mui/material";

import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";
import FilterListIcon from '@mui/icons-material/FilterList';
import dayjs from "dayjs";
import { useRef } from "react";
import Logo from "../../assets/companyLogo.png";
import { enqueueSnackbar } from "notistack";
import { DataTable } from "primereact/datatable";
import { useDispatch, useSelector } from "react-redux";
import { getIndentsData, handleIndentFilter, handleServiceFilter, handleServiceTemplateFilter } from "../api/Services/assetServices";
import { getServiceTemplateColumnDetails, getListOfSavedService, getListOfServiceTemplate, getListOfIndents, getListOfIndentsWithProjects, getListOfIndentsWithProjectsBending, getListOfIndentsWithProjectsSubmitted } from "../api/Services/masterServie";
import ReusablePrimeButton from "../Component/Buttons/ReusablePrimeButton";
import ReusableDataTable from "../Component/DataTable/ReusableDataTablePrime";
import { indentBodyTableIcon, getIndentsColumns, getIndentsButtonData } from "../const/AssertData";
import { CustomMessage } from "../const/Spinner";
import { setLoading } from "../store/CommonSlice";
import { IndentData, IndentFormData, ServiceColumn } from "../types/assetTypes";
import ServiceCreatingForm from "./Masters/ServiceCreatingForm";
import ServiceEditingForm from "./Masters/ServiceEditingForm";
import { RootState } from "../store/Reduxstore";
import CreateTemplate from "./Masters/CreateService";
import EditIndents from "./EditIndents";
import CreatingIndents from "./CreatingIndents";
import CreatingIndentStageTwo from "./CreatingIndentStageTwo";
import CreatingIndentStageThree from "./CreatingIndentStageThree";





interface IndentsProps {
  setPathname: (path: string) => void;
}
const IndentsMain: React.FC<IndentsProps> = ({
  setPathname,
}) => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();
  const [selectedStage, setSelectedStage] = useState<string>("stage1");
  const [indentPrimaryId, setIndentPrimaryId] = useState<number | null>(null);
  const [submittedPayload, setSubmittedPayload] = useState<IndentFormData | null>(null);

  useEffect(() => {
    if (indentPrimaryId) {
      console.log("indentPrimaryId updated in state:", indentPrimaryId);
    }
  }, [indentPrimaryId]);


  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState<IndentFormData>({
    indentId: 0,
    username: "",          // Empty string for username
    indentNo: 0,           // Initial value as 0 for indentNo
    countryName: "",       // Empty string for countryName
    currentLocationId: 0,  // Initial value as 0 for currentLocationId
    requestTo: "",         // Empty string for requestTo
    requestToId: 0,        // Initial value as 0 for requestToId
    requestFromId: 0,      // Initial value as 0 for requestFromId
    requestFrom: "",       // Empty string for requestFrom
    address: "",           // Empty string for address
    mapLocation: "",       // Empty string for mapLocation
    date: "",              // Empty string for date
    defaultList: "",       // Empty string for defaultList
    notify: "",            // Empty string for notify
    notes: "",             // Empty string for notes
    userId: 0,             // Initial value as 0 for userId
    indentPrimaryId: 0,
    section: [],
    status: 0,
    userIds: []
  });

  const [indentId, setIndentId] = useState<number | null>(null);
  const userDetails = useSelector((state: RootState) => state.auth);
  const [userId, setUserId] = useState<number>(userDetails.userId); // default to 0 or null
  console.log("details:", userDetails);
  type ViewType = "all" | "drafts" | "submitted";

  useEffect(() => {
    if (userDetails?.userId) {
      setUserId(userDetails.userId);
    }
  }, [userDetails?.userId]);



  const [products, setProducts] = useState<IndentFormData[]>([]);
  const [currentViewType, setCurrentViewType] = useState<ViewType>("all");
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  useEffect(() => {
    if (!open) {
      setSelectedStage("stage1");
    }
  }, [open]);

  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });

  console.log(userDetails);
  const actionBodyTemplate = (rowData: IndentFormData) => {
    const renderIconData = indentBodyTableIcon(
      handleEditIndents, handleViewIndent, rowData, currentViewType
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const columns = getIndentsColumns(actionBodyTemplate);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );




  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});
    setTempFilters({});
    // setCheckedValues([]);
    setSelectedValues([]);
    setFilterCol("");
    setSearchText("");
    setSubAnchorEl(null); // Close second popover if open
    setAnchorEl(null);
    setFilters({});    // Close first popover if open

    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };

  const handleDraftsClick = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfIndentsWithProjectsSubmitted(page, rows, userId, projectIds, filter, 0, searchTerm);;
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setCurrentViewType("drafts");
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleSubmittedClick = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfIndentsWithProjectsSubmitted(page, rows, userId, projectIds, filter, 1, searchTerm);;
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setCurrentViewType("submitted");
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  //for unique column names 

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);
    setFilterCol(col.key);
    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };

  type Filters = {
    [key: string]: {
      value: string[];
    };
  };


  type AssetItem = {
    id: number;
    name: string;
  };
  // const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  const [tempFilters, setTempFilters] = useState<Filters>({}); // ✨ temporary filters
  const [filterCol, setFilterCol] = useState<string>('');


  useEffect(() => {
    console.log("Updated filterCol inside useEffect:", filterCol);
  }, [filterCol]);


  const [columnData, setColumnData] = useState<AssetColumnData>({});
  const currentColValues = (columnData[filterCol] || []).map((item: { name: string }) => item.name);
  const filteredValues = currentColValues.filter((val: string) =>
    val.toLowerCase().includes(searchText.toLowerCase())
  );



  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };


  const openVisibilityPopover = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    dispatch(setLoading(true));

    const userId = userDetails?.userId ?? 0; // default to 0 if missing
    const projectIds = userDetails?.projectIds ?? [];

    try {
      const response = await handleIndentFilter({ userId, projectIds }); // pass params

      console.log("API Response:", response);

      if (response && response.status && response.status.code === 200 && response.data) {
        const data = response.data;
        setColumnData(data);

        const formattedCols = Object.keys(data).map((key) => ({
          key,
          label: key.replace(/_/g, " "),
          values: data[key].map((item: { name: string }) => item.name),
        }));

        console.log("Formatted Columns:", formattedCols);
        setColumns(formattedCols);
      } else {
        CustomMessage("Failed to fetch valid data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };



  const buttonData = getIndentsButtonData(
    handleClearFilter,
    () => setOpen(true),
    openVisibilityPopover,
    () => handleDraftsClick(paginationData.page, paginationData.rows, {}), // Wrap handleDraftsClick
    () => handleSubmittedClick(paginationData.page, paginationData.rows, {}), // Wrap handleSubmittedClick
    { role: userDetails.role.map(r => r.roleName) }
  );

  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          gap: "16px",
          width: "100%",
        }}
      >
        {/* Icons (Buttons) and Search Box in the Same Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
          </div>

          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={closeVisibilityPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <FormGroup sx={{ p: 2, minWidth: 220 }}>
              {columnns.map((col) => (
                <Box
                  key={col.key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    px: 1,
                    py: 0.5,
                    '&:hover': { backgroundColor: '#f5f5f5', borderRadius: 1 },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilterCol(col.key);

                    const currentChecked =
                      tempFilters[col.key]?.value || filters[col.key]?.value || [];

                    openSubPopover(e, col);
                  }}
                >
                  <Typography variant="body2">{col.label}</Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCol(col.key);

                      const currentChecked =
                        tempFilters[col.key]?.value || filters[col.key]?.value || [];


                      openSubPopover(e, col); // Pass the full Column object here
                    }}

                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </FormGroup>
          </Popover>

          {/* Second Popover - value checkboxes */}
          <Popover
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubPopover}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Typography variant="body2" gutterBottom>
                Filter by {filterCol.replace(/_/g, ' ')}
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder={`Search ${filterCol}`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={
                        filteredValues.length > 0 &&
                        filteredValues.every((value) =>
                          tempFilters[filterCol]?.value?.includes(value)


                        )
                      }
                      onChange={(e) => {
                        const newChecked = e.target.checked
                          ? Array.from(new Set([
                            ...(tempFilters[filterCol]?.value),
                            ...filteredValues
                          ]))
                          : (tempFilters[filterCol]?.value).filter(
                            (v) => !filteredValues.includes(v)
                          );

                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));
                      }}
                    />
                  }
                  label={<Typography variant="body2">Select All</Typography>}
                />
              </Box>

              <Box sx={{ mt: 1 }}>
                {filteredValues.map((value, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          tempFilters[filterCol]?.value?.includes(value)

                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const current = tempFilters[filterCol]?.value || []; // Ensure current is always an array

                          const updated = isChecked
                            ? [...current, value] // Add value if checked
                            : current.filter((v) => v !== value); // Remove value if unchecked

                          setTempFilters((prev) => ({
                            ...prev,
                            [filterCol]: { value: updated },
                          }));
                        }}
                      />
                    }
                    label={<Typography variant="body2">{value}</Typography>}
                  />
                ))}
              </Box>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const newFilters: Filters = {
                      ...filters,
                      ...tempFilters,
                    };
                    setFilters(newFilters);
                    handleSubmit(newFilters);
                    setSearchText('');
                    closeSubPopover();
                    closeVisibilityPopover();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Popover>
          {/* Right Side - Search Box */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "8px 12px",
                marginLeft: "8px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff", // Keeping the original color
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };

  const [indentMode, setIndentMode] = useState<"draft" | "submitted">("draft");

  const handleViewIndent = async (
    indentId: number,
    indentPrimaryId: number
  ) => {
    setIndentMode("submitted");

    await handleEditIndents(
      indentId,
      indentPrimaryId,
      "submitted"
    );
  };

  const handleEditIndents = async (
    indentId: number,
    indentPrimaryId: number,
    mode: "draft" | "submitted" = "draft"
  ) => {

    setIndentMode(mode);

    console.log("Edit clicked:", { indentId, indentPrimaryId });

    if (!indentPrimaryId) {
      CustomMessage("Indent Primary ID missing", "error", enqueueSnackbar);
      return;
    }

    setIndentId(indentId);
    setIndentPrimaryId(indentPrimaryId);
    setUserId(userDetails?.userId ?? 0);

    try {
      dispatch(setLoading(true));

      const response = await getIndentsData(indentPrimaryId);

      if (response.status.code === 200 && response.data?.length) {

        const stages = response.data;

        const stage1 = stages.find(s => s.stage === 1) || null;
        const stage2 = stages.find(s => s.stage === 2) || null;
        const stage3 = stages.find(s => s.stage === 3) || null;

        setStage1Data(stage1);
        setStage2Data(stage2);
        setStage3Data(stage3);

        setIsEdit(true);
        setOpen(true);

        if (stage1) setSelectedStage("stage1");
        else if (stage2) setSelectedStage("stage2");
        else if (stage3) setSelectedStage("stage3");

      } else {
        CustomMessage("Failed to fetch indent details", "error", enqueueSnackbar);
      }

    } catch (err: any) {
      CustomMessage(err.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  // const handleViewIndent = (indentId: number, indentPrimaryId: number) => {
  //   const userId = userDetails?.userId;
  //   console.log('User ID:', userId); // Check if userId is valid
  //   console.log('Indent ID:', indentId); // Check if indentId is being passed properly
  //   console.log('Indent ID:', indentPrimaryId);

  //   setIndentId(indentId);
  //   setIndentPrimaryId(indentPrimaryId);
  //   setUserId(userId);
  //   setOpen(true);
  // };

  // const handleEditIndents = async (indentId: number, indentPrimaryId: number) => {
  //   console.log("Edit clicked:", { indentId, indentPrimaryId });

  //   if (!indentPrimaryId) {
  //     CustomMessage("Indent Primary ID missing", "error", enqueueSnackbar);
  //     return;
  //   }
  //   setIndentId(indentId);
  //   setIndentPrimaryId(indentPrimaryId);
  //   setUserId(userDetails?.userId ?? 0);

  //   if (!indentPrimaryId) return;

  //   try {
  //     dispatch(setLoading(true));

  //     const response = await getIndentsData(indentPrimaryId);

  //     if (response.status.code === 200 && response.data?.length) {
  //       const stages = response.data;

  //       const stage1 = stages.find(s => s.stage === 1) || null;
  //       const stage2 = stages.find(s => s.stage === 2) || null;
  //       const stage3 = stages.find(s => s.stage === 3) || null;

  //       // Set stage data first
  //       setStage1Data(stage1);
  //       setStage2Data(stage2);
  //       setStage3Data(stage3);

  //       // Only open edit dialog after stage data is set
  //       setIsEdit(true);
  //       setOpen(true);

  //       // Optional: set selected stage
  //       if (stage1) setSelectedStage("stage1");
  //       else if (stage2) setSelectedStage("stage2");
  //       else if (stage3) setSelectedStage("stage3");
  //     } else {
  //       CustomMessage("Failed to fetch indent details", "error", enqueueSnackbar);
  //     }
  //   } catch (err: any) {
  //     CustomMessage(err.message, "error", enqueueSnackbar);
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };



  // const handleEditIndents = (indentId: number, indentPrimaryId: number) => {
  //   const userId = userDetails?.userId;
  //   console.log('User ID:', userId); // Check if userId is valid
  //   console.log('Indent ID:', indentId); // Check if indentId is being passed properly
  //   console.log('Indent ID:', indentPrimaryId);

  //   setIndentId(indentId);
  //   setIndentPrimaryId(indentPrimaryId);
  //   setUserId(userId);
  //   setOpen(true);
  // };
  const projectIds = userDetails?.projectIds ?? [];




  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfIndentsWithProjects(page, rows, userId, projectIds, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setCurrentViewType("all");
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  // To track if we are in edit mode
  const [isEdit, setIsEdit] = useState(false);

  // To store data for each stage when editing
  const [stage1Data, setStage1Data] = useState<IndentData | null>(null);
  const [stage2Data, setStage2Data] = useState<IndentData | null>(null);
  const [stage3Data, setStage3Data] = useState<IndentData | null>(null);



  console.log("Stage:", selectedStage);



  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px", marginBottom: "10px" }}>
          Indents
        </h2>
      </Box>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[
              // "assetOwnerName",
              // "harmonyCode",
              // "codeType",
              // "familyAsset",
            ]}
            header={header}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditIndents(rowData.indentId, rowData.indentPrimaryId);
            }}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            filters={filterData}
            setFilters={setFilterData}
            pagination={paginationData}
            setPagination={setPaginationData}
          />
        </Box>
      ) : (
        <div>
          {/* Edit flow */}
          {isEdit && (
            <EditIndents
              stage1Data={stage1Data}
              stage2Data={stage2Data}
              stage3Data={stage3Data}
              setEditOpen={setEditOpen}
              setOpen={setOpen}
              setIsEdit={setIsEdit}
              setIndentId={setIndentId}
              setIndentPrimaryId={setIndentPrimaryId}
              userId={userId}
              indentId={indentId}
              indentPrimaryId={indentPrimaryId}
              setSelectedStage={setSelectedStage}
              setSubmittedPayload={setSubmittedPayload}
              submittedPayload={submittedPayload}
            />
          )}

          {/* Create flow */}
          {!isEdit && (
            <>
              {selectedStage === "stage1" && (
                <CreatingIndents
                  setOpen={setOpen}
                  setEditOpen={setEditOpen}
                  setIndentId={setIndentId}
                  setIndentPrimaryId={setIndentPrimaryId}
                  userId={userId}
                  indentId={indentId}
                  indentPrimaryId={indentPrimaryId}
                  setSelectedStage={setSelectedStage}
                  setSubmittedPayload={setSubmittedPayload}
                  submittedPayload={submittedPayload}
                />
              )}
              {selectedStage === "stage2" && (
                <CreatingIndentStageTwo
                  setOpen={setOpen}
                  setEditOpen={setEditOpen}
                  setIndentId={setIndentId}
                  setIndentPrimaryId={setIndentPrimaryId}
                  userId={userId}
                  indentId={indentId}
                  indentPrimaryId={indentPrimaryId}
                  setSelectedStage={setSelectedStage}
                  setSubmittedPayload={setSubmittedPayload}
                  submittedPayload={submittedPayload}
                />
              )}
              {selectedStage === "stage3" && (
                <CreatingIndentStageThree
                  setOpen={setOpen}
                  setEditOpen={setEditOpen}
                  setIndentId={setIndentId}
                  setIndentPrimaryId={setIndentPrimaryId}
                  userId={userId}
                  indentId={indentId}
                  indentPrimaryId={indentPrimaryId}
                  setSelectedStage={setSelectedStage}
                  setSubmittedPayload={setSubmittedPayload}
                  submittedPayload={submittedPayload}
                />
              )}
            </>
          )}
        </div>

      )}
    </div>
  );
};



export default IndentsMain;
